// extracted by mini-css-extract-plugin
export default {"container":"ConfirmArchiveEventModal_container__8m2Lw"};